import 'react-app-polyfill/ie11';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// SheerID stuff
import { setOptions, overrideComponent, setMetadata } from '@sheerid/jslib';
import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';

import { StepMedicalProfessionalPersonalInfoComponent } from './components/StepMedicalProfessionalPersonalInfo/StepMedicalProfessionalPersonalInfoComponent';
import { StepDocUploadComponent } from './components/StepDocUpload/StepDocUploadComponent';
import { StepSuccessComponent } from './components/StepSuccess/StepSuccessComponent';
import { StepPendingComponent } from './components/StepPending/StepPendingComponent';
import { StepErrorComponent } from './components/StepErrorComponent';
import { getQueryParamsByName } from './metadataQueryString';

setOptions(defaultOptions);

// @ts-ignore
overrideComponent('StepMedicalProfessionalPersonalInfoComponent', StepMedicalProfessionalPersonalInfoComponent);
// @ts-ignore
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);
// @ts-ignore
overrideComponent('StepPendingComponent', StepPendingComponent);
// @ts-ignore
overrideComponent('StepErrorComponent', StepErrorComponent);

const qsValue = getQueryParamsByName('qs') || '';
setMetadata({ qs: qsValue });

googleTagManagerHook();

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
